// This function allow to reference chunks
__webpack_require__.u = function(chunkId) {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "scripts/referral-external/" + chunkId + ".chunk/" + {493: "adcff6a9faf247d8",925: "037a75a4685374f0",98: "f8edf85088c98cf6",}[chunkId] + ".js"
}